<template>
    <div v-if="resource" class="resource">
        <div class="media">
            <img class="desktop" :src="resource.image.desktop.src" :alt="resource.image.alt" :title="resource.image.title" />
            <img class="mobile" :src="resource.image.mobile.src" :alt="resource.image.alt" :title="resource.image.title" />
        </div>
        <div class="content">
            <div class="title"> 
                <a :href="resource.url">
                    {{ resource.title }}
                </a>
            </div>
            <div class="date">
                {{ resource.date }}
            </div>
            <div class="description">
                {{ resource.description | striphtml | truncate(215) }}
            </div>
        </div>
    </div>
</template>

<script>
import content from '@/translations/content'

export default {
    name: 'Resource',
    mixins: [ content ],
    props: {
        resource: Object
    }
}
</script>
